import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BASEURL } from '../../Constants';
import Nav from './nav';
import { useParams } from 'react-router-dom';

const SettingsPage = () => {
  const [apiKey, setApiKey] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { pentest_id } = useParams();


  const fetchApiKey = (token) => {
    fetch(`${BASEURL}/pentest/apikey?pentest_id=${pentest_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          if (data.message === 'Invalid token') {
            navigate('/');
          }
          setError(data.message);
        } else {
          setApiKey(data.api_key || 'No API key available.');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching API key:', err);
        setError('Failed to fetch API key.');
        setLoading(false);
      });
  };

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      fetchApiKey(token);
    } else {
      console.error('No token found');
      navigate('/');
    }
  }, []);

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Main Content */}
      <Box sx={{ flexGrow: 1, padding: '20px', overflowX: 'auto' }}>
        {/* Header Section */}
        <Nav />

        <Card sx={{ padding: '20px', boxShadow: 3 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
            API Key
          </Typography>

          {loading ? (
            <CircularProgress />
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : (
            <Box
              sx={{
                backgroundColor: '#f5f5f5',
                border: '1px solid #e0e0e0',
                padding: '10px',
                borderRadius: '4px',
              }}
            >
              <Typography variant="body1">{apiKey}</Typography>
            </Box>
          )}
        </Card>
      </Box>
    </Box>
  );
};

export default SettingsPage;
